import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pharma-management',
  templateUrl: './pharma-management.component.html',
  styleUrls: ['./pharma-management.component.scss']
})
export class PharmaManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
